// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';

// Styling
import '../../../styles/planeditor.css'

export default class Button extends React.Component {
    // Default button with an icon on the left
    //  Default text: "Save"
    // Pass custom style to override
    //  Default icon: check mark
    //  Default color: primary-dark
    render = () => 
        <div
            className={"plan-editor-button " + (this.props.className ?? "")}
            style={this.props.style ?? {}}
            onClick={this.props.onClick}>
            {this.props.text ?? "Save"}
        </div>;
};